import Component from '@glimmer/component';

import CommonPopupsPopupBlueBubbleComponent from 'webapp/components/common/popups/popup-blue-bubble';

import type PopupContext from 'webapp/models-custom/popup/context';

interface Args {
	type: string;
	step: number;
}

export default class StorybookBlueBubbleItemComponent extends Component<{ Args: Args }> {
	private noop() {
		// storybook mock — intentionally empty
	}

	get mockModel(): PopupContext {
		const noop = this.noop;
		return {
			data: {
				type: this.args.type,
				step: this.args.step,
				onExplicitClose: noop,
				doAction: noop,
			},
			reposition: noop,
			close: () => Promise.resolve(),
		} as unknown as PopupContext;
	}

	<template>
		<div class="popup context-popup popup-type-blue-bubble storybook-bubble-static">
			<div class="popup-inner">
				<div class="content">
					<CommonPopupsPopupBlueBubbleComponent @model={{this.mockModel}} />
				</div>
			</div>
		</div>
	</template>
}
